import type { CacheDependencyFunc } from "Rule";
import RuleVertex from "RuleVertex";
import ko, { type Computed } from "knockout";
import type { DependencyStrategyContext } from "./DependencyStrategyContext";

export default class CalculatedPropertyVertex extends RuleVertex {
  private readonly cacheDependencyComputed?: Computed<void>;
  private readonly context: DependencyStrategyContext;
  private disposed: boolean;

  constructor(context: DependencyStrategyContext, cacheDependencyFunc: CacheDependencyFunc | undefined) {
    super(context.entity, context.rule);
    this.context = context;
    this.disposed = false;
    this.cacheDependencyComputed = cacheDependencyFunc ? this.createComputed(cacheDependencyFunc) : undefined;
  }

  dispose(): void {
    this.disposed = true;
    this.cacheDependencyComputed && this.cacheDependencyComputed.dispose();
  }

  override isValid(): boolean {
    return !this.disposed && super.isValid();
  }

  override async reportChangedAsync(): Promise<void> {
    this.wireDependencies();
    await this.context.handleChangedAsync();
  }

  private createComputed(cacheDependencyFunc: CacheDependencyFunc): Computed<void> {
    let valueHolder: { value: unknown } | undefined;
    return ko
      .computed(() => {
        if (!this.isValid()) {
          return;
        }

        const { entity } = this;
        const value = cacheDependencyFunc(entity);
        if (!valueHolder) {
          valueHolder = { value };
        } else if (valueHolder.value !== value) {
          valueHolder.value = value;
          this.context.handleChangedAsync();
        }
      })
      .extend({ deferred: true });
  }
}
